import Link from 'next/link';

/**
 * @name NavLink
 * @description Displays SubDropdownMenu of nav links
 * @param {*} props - React props
 * @returns {JSX.Element} NextJs Link Element
 */
const NavLink = props => <Link {...props} component='a' />;

NavLink.displayName = 'NavLink';
export default NavLink;
